<div class="alert_dialog" [ngSwitch]="data.type">
    <div *ngSwitchCase="'message'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header">{{data.title}}</div>
            <!-- <mat-icon class="clear" (click)="onNoClick()">clear</mat-icon> -->
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row"
            fxLayoutAlign="center center">
            <!-- <button class="button_2" mat-raised-button (click)="onNoClick()">Ok</button> -->
            <button class="button_3" mat-raised-button (click)="onNoClick()">Okay</button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmUnsavedChanges'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onNoClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Stay
            </button>
            <button class="button_3 cursor_pointer" mat-raised-button fxLayout="row" [mat-dialog-close]="data.type"
                fxLayoutAlign="center center">
                Leave
            </button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmUnsavedChangesCustom'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onNoClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Close
            </button>
            <button class="button_3 cursor_pointer" mat-raised-button fxLayout="row" [mat-dialog-close]="data.type"
                fxLayoutAlign="center center">
                {{data.buttonText?data.buttonText:'Discard'}}
            </button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmDelete'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning'"></mat-icon>
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onLeaveClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_1 cursor_pointer" mat-raised-button fxLayout="row" (click)="onNoClick()"
                [mat-dialog-close]="data.type" fxLayoutAlign="center center">
                {{data.buttonText?data.buttonText:'Delete'}}

            </button>
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Cancel
            </button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmDeny'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning'"></mat-icon>
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onLeaveClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">

            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Cancel
            </button>
            <button class="button_1 cursor_pointer" mat-raised-button fxLayout="row" (click)="onNoClick()"
                [mat-dialog-close]="data.type" fxLayoutAlign="center center">
                {{data.buttonText?data.buttonText:'Delete'}}

            </button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmDisable'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning_orange'" style="color: #e26800;"></mat-icon>
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onLeaveClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_4 cursor_pointer" mat-raised-button fxLayout="row" (click)="onNoClick()"
                [mat-dialog-close]="data.type" fxLayoutAlign="center center">
                Disable
            </button>
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Cancel
            </button>
        </div>
    </div>
    <div *ngSwitchCase="'completeRegistrationForm'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onLeaveClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                [mat-dialog-close]="data.type" fxLayoutAlign="center center">
                Cancel
            </button>
            <button class="button_3 cursor_pointer" mat-raised-button fxLayout="row" (click)="onNoClick()"
                fxLayoutAlign="center center">
                Continue to Registration Form
            </button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmDiscardChanges'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onNoClick()">clear</mat-icon>
        </div>
        <div class="text_2">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_2" mat-raised-button (click)="onNoClick()">Cancel</button>
            <button class="button_3" mat-raised-button [mat-dialog-close]="data.type">Discard</button>
        </div>
    </div>
    <div *ngSwitchCase="'warning'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning-box'"></mat-icon>
            <div class="header">{{data.title}}</div>
        </div>
        <div class="text_3">{{data.message}}</div>
        <div fxFlex="100" class="width_100 alert_footer no-border" fxLayoutGap="20px" fxLayout="row"
            fxLayoutAlign="center center">
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                OK
            </button>
        </div>
    </div>

    <div *ngSwitchCase="'inActiveHotel'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning'"></mat-icon>
            <div class="header">404 Page Not Found</div>
        </div>
        <div class="text_2">Sorry, the page you're trying to access is no longer available. Please <a
                (click)="contactSupport()" style="color: #2680eb;text-decoration: underline;cursor: pointer;">contact
                support</a> for assistance.</div>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_3" mat-raised-button (click)="onLeaveClick()">Go Back</button>
        </div>
    </div>
    <div *ngSwitchCase="'confirmCancellation'" fxFlex="100" fxLayout="column" fxLayoutAlign="start center">
        <div class="width_100" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
            <mat-icon [svgIcon]="'warning_orange'" style="color: #D9480E;"></mat-icon>
            <div class="header">{{data.title}}</div>
            <mat-icon class="clear" (click)="onLeaveClick()">clear</mat-icon>
        </div>
        <div class="text_4">{{data.message}}</div>
        <form [formGroup]="cancelForm" fxFlex="100" fxLayout="column" style="padding:0px 20px;width: 100%;"
            fxLayoutAlign="start start">
            <label for="reason" style="color: #ADB5BD;margin-bottom: 5px;font-size: 13px;">Reason for cancellation <span
                    class="required">*</span></label>
            <mat-select id="reason" formControlName="reason" placeholder="Select reason" class="reason-dropdown" (selectionChange)="reasonChanged($event)">
                <mat-option *ngFor="let reason of reasons" [value]="reason">{{ reason }}</mat-option>
            </mat-select>
        </form>
        <div fxFlex="100" class="width_100 alert_footer" fxLayoutGap="20px" fxLayout="row" fxLayoutAlign="end center">
            <button class="button_5 cursor_pointer" mat-raised-button fxLayout="row" (click)="onCancelClick()"
                [mat-dialog-close]="data.type" fxLayoutAlign="center center">
                Confirm Cancellation
            </button>
            <button class="button_2 cursor_pointer" mat-raised-button fxLayout="row" (click)="onLeaveClick()"
                fxLayoutAlign="center center">
                Cancel
            </button>
        </div>
    </div>
</div>